<template>
  <div class="sides-page">
    <hint-page v-if="showHint" @close="showHint = false">
      <i>click on the&nbsp;</i>
      <b>“X”</b>
      <i>&nbsp;and&nbsp;</i>
      <b>“O”</b>
      <i>&nbsp;to define an adversary and advocate.</i>
    </hint-page>

    <hint-page v-show="showConfirm" @close="showConfirm = false">
      <i>you have selected </i><b>the {{ side }}</b>
    </hint-page>

    <adv-title>Select approach</adv-title>

    <img
      :class="{ disabled: side == 'advocate' }"
      src="~@/assets/images/icon-adversary.png"
      alt="ADVERSARY"
      @click="$store.dispatch('setSide', 'adversary')"
    />
    <img
      :class="{ disabled: side == 'adversary' }"
      src="~@/assets/images/icon-advocate.png"
      alt="ADVOCATE"
      @click="$store.dispatch('setSide', 'advocate')"
    />

    <h1 class="side-title" v-show="side == 'adversary'">
      <b>[ THE ADV</b>ERSARY
      <b>]</b>
      <br />
      <i
        >disrupt the operations of a person, group, organisation or ideology to
        change the beneficiaries.</i
      >
    </h1>

    <h1 class="side-title" v-show="side == 'advocate'">
      <b>[ THE ADV</b>OCATE
      <b>]</b>
      <br />
      <i
        >Enable a person, group or organisation to maintain and reinforce their
        impact.</i
      >
    </h1>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AdvTitle from "../components/AdvTitle.vue";
import HintPage from "./HintPage.vue";

export default {
  name: "sides-page",
  components: { HintPage, AdvTitle },
  computed: {
    ...mapState(["side"]),
  },
  data: function () {
    return {
      showHint: true,
      showConfirm: false,
    };
  },
  methods: {},
  watch: {
    side: function (val) {
      this.showConfirm = true;
    },
  },
};
</script>

<style lang="less">
.sides-page {
  position: relative;
  width: 768px;
  height: 768px;
  background-image: url("~@/assets/images/page-blank.png");
  padding: 120px;

  .side-title {
    margin-top: 28px;
  }

  img {
    &.disabled {
      opacity: 0.25;
    }
  }
}

.sides-page img {
  cursor: not-allowed;
}
.controller .sides-page img {
  cursor: pointer;
}
</style>
